import { QRTrackConstants} from "../constants";

export function QRTrack(state = {}, action) {
  switch (action.type) {
    // 📌 Request to get scan info
    case QRTrackConstants.TRACK_SCAN_INFO_REQUEST:
      return {
        ...state,
        toggleLoading: true,
      };

    // ✅ Success: Store TIDproducts inside scanInfo object
    case QRTrackConstants.TRACK_SCAN_INFO_SUCCESS:
      return {
        ...state,
        scanInfo: {
          TIDproducts: action.datas, // updated structure
        },
        qrs: false,
        did: true,
        tid: false,
        sid: false,
      };

    // ❌ Failure: Store error
    case QRTrackConstants.TRACK_SCAN_INFO_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    // 📌 Toggle request
    case QRTrackConstants.TRACK_TOGGLE_REQUEST:
      return {
        ...state,
        toggleLoading: true,
      };

    case QRTrackConstants.TRACK_TOGGLE_SUCCESS:
      return {
        ...state,
        iddata: action.datas,
      };

    case QRTrackConstants.TRACK_TOGGLE_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    // 📌 Toggle 2 request
    case QRTrackConstants.TRACK_TOGGLE_2_REQUEST:
      return {
        ...state,
        toggle2Loading: true,
      };

    case QRTrackConstants.TRACK_TOGGLE_2_SUCCESS:
      return {
        ...state,
        iddata2: action.datas,
      };

    case QRTrackConstants.TRACK_TOGGLE_2_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    // 📌 Request to get journey info
    case QRTrackConstants.TRACK_JOURNEY_INFO_REQUEST:
      return {
        ...state,
        toggleLoading: true,
      };

    // ✅ Success: Store journeyList
    case QRTrackConstants.TRACK_JOURNEY_INFO_SUCCESS:
      return {
        ...state,
        journeyList: action.datas,
        qrs: true,
        did: false,
        tid: false,
        sid: false,
      };

    case QRTrackConstants.TRACK_JOURNEY_INFO_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    default:
      return state;
  }
}